export default __webpack_public_path__ + "static/media/google_play.0c1dfd93.svg";